export default "__VITE_PUBLIC_ASSET__f4e32afa__"